import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_ADD,
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_EDIT,
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_UPDATE,
    ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_RESET,
    CollectionInstanceTrackerPageAction
} from '../../actions/pages/collectionInstanceTrackerPage';


export interface ICollectionInstanceTrackerPageState {
    modalOpen: boolean;
    collectionInstanceTrackerIndex: number;
    collectionInstanceTracker: Dtos.CollectionInstanceTracker;
    isValid: boolean;
}

const initialState: ICollectionInstanceTrackerPageState = {
    modalOpen: false,
    collectionInstanceTrackerIndex: -1,
    collectionInstanceTracker: undefined,
    isValid: false
};


function addTracker(state: ICollectionInstanceTrackerPageState, collectionInstanceId: number): ICollectionInstanceTrackerPageState {
    let collectionInstanceTracker = new Dtos.CollectionInstanceTracker();
    collectionInstanceTracker.collectionInstanceId = collectionInstanceId;
    const newState: ICollectionInstanceTrackerPageState = update(state, {
        modalOpen: {
            $set: true
        },
        collectionInstanceTrackerIndex: {
            $set: -1
        },
        collectionInstanceTracker: {
            $set: collectionInstanceTracker
        }
    });
    return validate(newState);
}

function editTracker(state: ICollectionInstanceTrackerPageState, index: number, collectionInstanceTracker: Dtos.CollectionInstanceTracker): ICollectionInstanceTrackerPageState {
    const newState: ICollectionInstanceTrackerPageState = update(state, {
        modalOpen: {
            $set: true
        },
        collectionInstanceTrackerIndex: {
            $set: index
        },
        collectionInstanceTracker: {
            $set: collectionInstanceTracker
        }
    });
    return validate(newState);
}

function updateTracker(state: ICollectionInstanceTrackerPageState, collectionInstanceTracker: Dtos.CollectionInstanceTracker): ICollectionInstanceTrackerPageState {
    const newState: ICollectionInstanceTrackerPageState = update(state, {
        collectionInstanceTracker: {
            $set: collectionInstanceTracker
        }
    });
    return validate(newState);
}

function validate(state: ICollectionInstanceTrackerPageState): ICollectionInstanceTrackerPageState {
    let isValid = true;
    //if (!state.collectionInstanceTracker.comment || state.collectionInstanceTracker.comment == "") {
    //    isValid = false;
    //}
    if (!state.collectionInstanceTracker.date || state.collectionInstanceTracker.date == "") {
        isValid = false;
    }
    if (!state.collectionInstanceTracker.collectionInstanceTrackerTypeId || state.collectionInstanceTracker.collectionInstanceTrackerTypeId < 1) {
        isValid = false;
    }
    const newState: ICollectionInstanceTrackerPageState = update(state, {
        isValid: {
            $set: isValid
        }
    });
    return newState;
}

function resetTracker(state: ICollectionInstanceTrackerPageState): ICollectionInstanceTrackerPageState {
    const newState: ICollectionInstanceTrackerPageState = update(state, {
        modalOpen: {
            $set: false
        },
        collectionInstanceTrackerIndex: {
            $set: -1
        },
        collectionInstanceTracker: {
            $set: undefined
        }
    });
    return newState;
}

const CollectionInstanceTrackerPageReducer: Reducer<ICollectionInstanceTrackerPageState> = (state: ICollectionInstanceTrackerPageState = initialState, action: CollectionInstanceTrackerPageAction) => { 
    switch (action.type) {
        case ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_ADD:
            return addTracker(state, action.collectionInstanceId);
        case ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_EDIT:
            return editTracker(state, action.index, action.collectionInstanceTracker);
        case ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_UPDATE:
            return updateTracker(state, action.collectionInstanceTracker);
        case ACTION_COLLECTION_INSTANCE_TRACKER_PAGE_RESET:
            return resetTracker(state);
    }

    return state;
}

export default CollectionInstanceTrackerPageReducer;